import { makeStyles } from 'tss-react/mui';

const useStylesChip: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  chip: {
    height: 'auto !important',
    minHeight: 32,
    margin: '3px !important',
    textAlign: 'center',
    cursor: 'pointer',
    borderColor: `${theme.palette.primary.dark} !important`,
    '& > span': {
      padding: '2px 12px 0',
      whiteSpace: 'normal !important',
      wordBreak: 'break-word',
    },
  },
  chipDisabled: {
    cursor: 'default',
    borderColor: `${theme.palette.action.disabled} !important`,
  },
  chipHighlighted: {
    borderColor: `${theme.palette.secondary.main} !important`,
    color: `${theme.palette.secondary.main} !important`,
  },
  chipImageOffset: {
    marginLeft: '7px !important',
  },
  chipLabelHighlighted: {
    color: `${theme.palette.secondary.main} !important`,
  },
  chipDeleteIcon: {
    margin: '0 4px 0 auto !important',
    color: `${theme.palette.primary.dark} !important`,
  },
  chipDeleteIconHighlighted: {
    color: `${theme.palette.secondary.main} !important`,
    '&:hover': {
      color: `${theme.palette.secondary.main} !important`,
    },
  },
}));

export default useStylesChip;
